/* CREALIS — red de seguridad para el drawer del carrito (2026-07-20).
   Reporte: tras agregar varios productos seguidos con el drawer abierto,
   "Pagar" a veces no hacía nada / parecía agregar otra unidad en su lugar.
   Hallazgo al investigar: la animación nativa de apertura del drawer
   (keyframe "slideInLeft", en base.css) a veces se queda pegada en su
   fotograma INICIAL (transform: translateX(...) sin llegar nunca a 0) —
   el <dialog> se ve bien en pantalla pero el navegador ubica sus elementos
   clicleables en la posición "sin animar" (fuera del punto real donde el
   usuario toca), así que los clics ahí no aterrizan en nada.
   Esta red de seguridad no reemplaza la animación: solo la fuerza a
   terminar si no se asentó sola después de un tiempo generoso (450ms,
   bastante más que cualquier transición normal) — en el caso normal (99%
   de las veces) no hace nada, es un no-op. */
(function () {
  if (window.crFixDrawerAnim) return;
  window.crFixDrawerAnim = true;

  function forzarSiQuedoPegado(dlg) {
    var t = getComputedStyle(dlg).transform;
    var asentado = !t || t === 'none' || t.indexOf('1, 0, 0, 1, 0, 0') > -1;
    if (!asentado) {
      dlg.style.setProperty('animation', 'none', 'important');
      dlg.style.setProperty('transform', 'none', 'important');
    }
  }

  function vigilar(dlg) {
    var timer = null;
    function revisarPronto() {
      if (!dlg.open) return;
      clearTimeout(timer);
      timer = setTimeout(function () { forzarSiQuedoPegado(dlg); }, 450);
    }
    /* Se re-pega no solo al ABRIR el drawer, sino también en morphs
       posteriores (agregar un 2º/3er producto con el drawer ya abierto,
       clickear una oferta, etc.) — se revisa en AMBOS disparadores: el
       atributo "open" cambiando, y cada evento cart:update mientras siga
       abierto (el atributo "open" no cambia en esos casos, así que un
       observer solo sobre "open" se pierde estos re-enganches). */
    new MutationObserver(revisarPronto).observe(dlg, { attributes: true, attributeFilter: ['open'] });
    document.addEventListener('cart:update', revisarPronto);
  }

  function iniciar() {
    var dlg = document.querySelector('cart-drawer-component dialog');
    if (dlg) vigilar(dlg);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
